<template>
  <div>
    <j-modal
      :visible.sync="visible"
      switchFullscreen
      :width="'90%'"
      @cancel="visible = false"
      :maskClosable="false"
      :destroyOnClose="true"
      onOk="handleOk"
      :footer="null"
    >
      <div slot="title">
        <span>{{ unit.unitName }}</span>
        <a-divider v-if="unit.unitIntro" type="vertical"></a-divider>
        <a-icon type="question-circle" theme="twoTone" @click="showUnitInfo" />
      </div>
      <a-spin v-if="loading" tip="加载中..." style="display: block; margin: 50px auto"></a-spin>
      <a-row v-else :gutter="24">
        <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
          <div class="video-area" id="media-content">
            <!-- 课程视频 -->
            <video
              v-if="videoUrl"
              oncontextmenu="return false;"
              controlsList="nodownload noremote footbar"
              :src="videoUrl"
              controls="true"
              @canplay="handleVideoInit"
              @play="handleVideoPlay"
              @timeupdate="handleVideoUpdate"
              @pause="handleVideoPause"
              @ended="handleVideoEnded"
            ></video>
            <!-- 富文本 -->
            <a-icon
              v-if="mediaContent"
              class="download-media-content-icon"
              type="download"
              @click="downloadMediaContent"
            />
            <div ref="html2canvas" v-if="mediaContent" v-html="mediaContent"></div>
          </div>
        </a-col>
        <a-divider v-if="_isMobile()" />
        <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="unit-list">
            <a-timeline>
              <a-timeline-item color="blue" v-for="(media, index) in mediaList" :key="media.id">
                <a-icon v-if="media.mediaType == 5" slot="dot" type="edit" style="font-size: 16px" />
                <a-icon v-if="media.mediaType == 1" slot="dot" type="play-circle" style="font-size: 16px" />
                <a-icon v-if="media.mediaType == 3" slot="dot" type="snippets" style="font-size: 16px" />
                <a-collapse v-if="media.mediaPath.includes(',')" defaultActiveKey="1">
                  <a-collapse-panel
                    key="1"
                    :header="media.mediaName"
                    :style="{ backgroundColor: currentMediaIndex == index ? '#e2edff' : '#fafafa' }"
                  >
                    <a-button
                      style="display: block; margin-bottom: 5px; width: 100%"
                      size="small"
                      v-for="(val, i) in media.mediaPath_fileinfo"
                      :key="i"
                      @click="changeMedia(media, index, val.key)"
                      :type="currentMediaIndex == index && currentMediaFile == val.key ? 'primary' : 'default'"
                    >
                      {{ val.fileName }}<a-icon type="right" />
                    </a-button>
                  </a-collapse-panel>
                </a-collapse>
                <a-button
                  v-else
                  block
                  @click="changeMedia(media, index)"
                  :type="currentMediaIndex == index ? 'primary' : 'default'"
                >
                  {{ media.mediaName }}<a-icon type="right" />
                </a-button>
              </a-timeline-item>
            </a-timeline>
            <!-- <a-card v-if="unit.unitIntro" size="small" title="课程说明">
              <div v-html="unit.unitIntro ? unit.unitIntro.replace(/\n/g,'<br>') : ''"></div>
            </a-card> -->
          </div>
        </a-col>
      </a-row>
      <a-modal
        :width="'800px'"
        :visible="unitInfoVisible"
        :title="unit.unitName"
        :destroyOnClose="true"
        :footer="null"
        @cancel="unitInfoVisible = false"
      >
        <div v-html="unit.unitIntro"></div>
      </a-modal>
    </j-modal>
  </div>
</template>
<script>
// import '@/components/jeecg/JModal'
import { getAction } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin.js'
import { getQiniuUrl, getQiniuFile } from '@/utils/qiniu.js'
import html2canvas from 'html2canvas'
import { saveAs } from 'file-saver'
export default {
  name: 'UnitViewModal',
  mixins: [mixinDevice],
  data() {
    return {
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',
      visible: false,
      loading: false,
      unitInfoVisible: false,
      unit: {},
      videoUrl: '',
      mediaList: [],
      url: {
        unitMedia: '/teaching/teachingCourseUnit/unitMedia',
        studyLog: '/teaching/teachingStudyLog/study',
        unitStudyLog: '/teaching/teachingStudyLog/getUnitStudyLog',
      },
      mediaContent: '',
      currentMedia: {},
      currentMediaIndex: 0,
      currentMediaFile: 0,
      lastPlayTime: 0, //上次视频观看进度
      cacheDuration: 0, //等待提交的进度
    }
  },
  mounted() {
    // contextmenu 禁用右键菜单
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault()
    })
    // //禁止复制  selectstart
    // document.addEventListener('selectstart',function(e){
    //     e.preventDefault();
    // })
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    showUnitInfo() {
      this.unitInfoVisible = true
    },
    handleCancel(e) {
      this.visible = false
      this.unit = {}
      this.videoUrl = ''
      this.mediaList = []
    },
    view(unit) {
      console.log(unit)
      this.visible = true
      this.currentMediaIndex = 0
      this.unit = unit
      this.getCourseMedia(unit.id)
      this.getUnitStudyLog()
    },
    getCourseMedia(unitId) {
      this.loading = true
      getAction(this.url.unitMedia, { id: unitId })
        .then((res) => {
          this.loading = false
          if (res.success) {
            this.mediaList = res.result
            for (let i = 0; i < this.mediaList.length; i++) {
              let item = this.mediaList[i]
              if ([1, 7].includes(item.mediaType)) {
                this.changeMedia(item, i)
                break
              }
              console.log(item.mediaPath_fileinfo)
            }
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((e) => {
          console.log(e)
          this.loading = false
          let data = e.response.data
          if (data.message.includes('Token失效')) {
            this.$message.error('未登录')
          }
        })
    },
    changeMedia(media, index, mediaFile) {
      this.currentMedia = media
      this.currentMediaIndex = index
      this.currentMediaFile = mediaFile
      let url
      if (media.mediaPath.includes(',')) {
        if (mediaFile) {
          url = this.searchObjByKey(media.mediaPath_fileinfo, 'key', mediaFile)['url']
        } else {
          url = media.mediaPath_fileinfo[0]['url']
          this.currentMediaFile = media.mediaPath_fileinfo[0]['key']
        }
      } else {
        url = media.mediaPath_url
      }

      console.log('changeMedia', media, index, mediaFile, url)
      switch (media.mediaType) {
        case 1: //教学视频
          this.mediaContent = ''
          this.videoUrl = url
          break
        case 3: //课堂练习
        case 5: //课后作业
          this.handleViewCode(media, mediaFile)
          break
        case 6: //PPT
          // if(media.mediaPath_url.endsWith('ppt') || media.mediaPath_url.endsWith('pptx') ){
          window.open(`/fileView?url=` + encodeURIComponent(btoa(url)))
          // }else{
          // window.open(media.mediaPath_url)
          // }
          break
        case 7: //富文本
          this.videoUrl = ''
          this.mediaContent = media.mediaContent
          this.studyLog(0, 0, true)
          break
        case 8: //OJ
          window.open('/onlinecode/index.html?questionId=' + media.questionId)
          break
        default:
          window.open(url)
      }
    },
    searchObjByKey(list, key, value) {
      for (let i = 0; i < list.length; i++) {
        if (list[i][key] == value) {
          return list[i]
        }
      }
      return {}
    },
    handleVideoInit() {
      console.log('video init')
      this.studyLog(0, 0, false)
    },
    handleVideoPlay() {
      console.log('play')
    },
    handleVideoPause() {
      console.log('pause')
    },
    handleVideoEnded(e) {
      console.log('ended')
      let duration = e.target.duration
      this.currentMedia.finished = true
      this.studyLog(parseInt(duration), parseInt(this.cacheDuration), true)
    },
    handleVideoUpdate(e) {
      let rate = 10 //日志记录频率
      let currentTime = e.target.currentTime
      let duration = e.target.duration
      this.cacheDuration += currentTime - this.lastPlayTime
      this.lastPlayTime = currentTime
      //播放10秒记录日志
      if (this.cacheDuration > rate) {
        studyLog(parseInt(duration), parseInt(this.cacheDuration), false)
        this.cacheDuration = 0
      }
    },
    //记录学习日志
    studyLog(videoTime, duration, finished) {
      getAction(this.url.studyLog, {
        mediaId: this.currentMedia.id,
        mediaType: this.currentMedia.mediaType,
        unitId: this.unit.id,
        courseId: this.unit.courseId,
        videoTime,
        duration,
        finished,
      }).then((res) => {})
    },
    getUnitStudyLog() {
      getAction(this.url.unitStudyLog, { courseId: this.unit.courseId, unitId: this.unit.id })
    },
    handleViewCode(media, mediaFile) {
      switch (media.codeType) {
        case 1:
          window.open(
            '/scratch3/index.html?scene=twl&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 2:
          window.open(
            '/scratch3/index.html?scene=twl&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 3:
          return window.open('/scratchjr/editor.html?mode=edit&filepath=' + media.mediaPath_url.split(',')[mediaFile])
          break
        case 4:
          return window.open(
            '/onlinecode/index.html?lang=turtle&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 5:
          return window.open(
            '/onlinecode/index.html?lang=python&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 6:
          return window.open(
            '/onlinecode/index.html?lang=c&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 7:
          return window.open(
            '/onlinecode/index.html?lang=cpp&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 8:
          return window.open(
            '/onlinecode/index.html?lang=java&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        default:
          window.open(this.getQiniuFile(media.mediaPath_url))
      }
    },
    downloadMediaContent() {
      let that = this
      let contentDom = document.getElementById('media-content')
      contentDom.scrollTop = 0
      html2canvas(this.$refs.html2canvas, {
        backgroundColor: 'white',
        useCORS: true, // 解决文件跨域问题
        height: contentDom.scrollHeight,
        windowHeight: contentDom.scrollHeight,
      }).then((canvas) => {
        const url = canvas.toDataURL('image/png') // 生成的图片
        saveAs(url, that.unit.unitName + '-' + that.currentMedia.mediaName + '.png')
      })
    },
  },
}
</script>
<style lang="less" scoped>
.video-area {
  max-height: 700px;
  overflow: auto;
  video {
    width: 100%;
    height: 700px;
    // min-height: 500px;
  }
}
.unit-list {
  vertical-align: top;
  padding: 10px;
  margin: 0 20px;
  max-height: 700px;
  overflow-y: auto;
  /deep/.ant-btn {
    text-align: left;
  }
}

.download-media-content-icon {
  opacity: 1;
  color: black;
  font-size: 24px;
  line-height: 24px;
  position: absolute;
  top: 2px;
  right: 24px;
  z-index: 9;
  cursor: pointer;
  transition: opacity 0.3s;
}
</style>
